export function isWorkShop(type) {
    return type === BuildingType.WORKSHOP_1 ||
        type === BuildingType.WORKSHOP_2 ||
        type === BuildingType.WORKSHOP_3;
}
export function isHomeOrFarm(type) {
    return BuildingType.HOME === type || BuildingType.FARM === type;
}
export function getBuildingTypeName(type) {
    switch (type) {
        case BuildingType.HOME: return 'Homes';
        case BuildingType.FARM: return 'Farms';
        case BuildingType.BARRACKS: return 'Barracks';
        case BuildingType.WORKSHOP_1: return 'Workshops';
        case BuildingType.WORKSHOP_2: return 'Workshops';
        case BuildingType.WORKSHOP_3: return 'Workshops';
        case BuildingType.CULTURE: return 'Culture';
        case BuildingType.COLLECTABLE: return 'Collectable';
        case BuildingType.EVENT: return 'Evolving';
        case BuildingType.CITY_HALL: return 'City Hall';
    }
    return 'N/A';
}
var BuildingType;
(function (BuildingType) {
    BuildingType["HOME"] = "home";
    BuildingType["FARM"] = "farm";
    BuildingType["BARRACKS"] = "barracks";
    BuildingType["WORKSHOP_1"] = "workshop1";
    BuildingType["WORKSHOP_2"] = "workshop2";
    BuildingType["WORKSHOP_3"] = "workshop3";
    BuildingType["CULTURE"] = "culture";
    BuildingType["COLLECTABLE"] = "collectable";
    BuildingType["EVENT"] = "event";
    BuildingType["CITY_HALL"] = "city-hall";
})(BuildingType || (BuildingType = {}));
export default BuildingType;
